import { TravelTypes } from '../constants';

const isOutboundFlightLegExistsInBrochure = (brochure, flightKey) => {
  if (!brochure || !brochure.trips) return undefined;
  let result;
  Object.keys(brochure.trips).some((brochureId) => {
    const trip = brochure.trips[brochureId];
    return trip.tripSegments.some((segment) => {
      const segmentKeys = segment.itinerary.flightKey?.split('|') || [];
      if (
        segment.itinerary.mode === TravelTypes.flight &&
        segment.itinerary.flightSegments.length > 1 &&
        segmentKeys.includes(flightKey)
      ) {
        result = { segment, brochureId };
        return true;
      }
      return false;
    });
  });
  return result;
};

export default isOutboundFlightLegExistsInBrochure;
